/**
 * National baseline RPM by equipment family.
 *
 * Updated weekly by Tim. Source: national spot market averages.
 * Last updated: 2026-05-26
 *
 * Used ONLY as a final L5 fallback inside computeSpotRate when all
 * live + historical + daily-baseline tiers return no comps.
 *
 * Equipment outside this map (step_deck, power_only, lowboy, tankers,
 * sprinter, etc.) intentionally returns null → "Insufficient data".
 */
export const NATIONAL_BASELINE_RPM: Record<string, number> = {
  van: 2.79,
  reefer: 3.26,
  flatbed: 3.60,
};
